import * as FeatherIcons from 'vue-feather-icons';

export default {
    items: [
        {
            name: 'Dashboard',
            type: 'dashboard',
            route: 'dashboard',
            iconComponent: FeatherIcons.GridIcon,
            group: 'general',
        },
        {
            name: 'Content',
            children: [
                { name: 'Pages', route: 'pages', type: 'page' },
                { name: 'Panel library', route: 'panels', type: 'panel' },
                // { name: 'Staff Members', route: 'staff_members', type: 'staff_member' },
            ],
            iconComponent: FeatherIcons.LayersIcon,
            group: 'general',
        },
        // {
        //     name: 'News',
        //     route: 'posts',
        //     type: 'post',
        //     iconComponent: FeatherIcons.FileTextIcon,
        //     group: 'general',
        // },
        {
            name: 'Assets',
            route: 'assets',
            type: 'asset',
            iconComponent: FeatherIcons.ImageIcon,
            group: 'general',
        },
        {
            name: 'Products',
            children: [
                { name: 'Products', route: 'products', type: 'product' },
                { name: 'Lookup', route: 'lookup', type: 'lookup' },
                { name: 'Makes', route: 'makes', type: 'make' },
                { name: 'Models', route: 'make_models', type: 'make_model' },
                { name: 'Attributes', route: 'product_attributes', type: 'product_attribute' },
                { name: 'Categories', route: 'categories', type: 'category' },
                { name: 'Brands', route: 'brands', type: 'brand' },
            ],
            iconComponent: FeatherIcons.BoxIcon,
            group: 'catalogue',
        },
        {
            name: 'Customers',
            children: [
                { name: 'Customers', route: 'customers', type: 'customer' },
                { name: 'Logins', route: 'customer_logins?filter=approved:1', type: 'customer_login' },
                { name: 'Pending Registrations', route: 'customer_logins?filter=approved:0', type: 'customer_login' },
            ],
            iconComponent: FeatherIcons.UsersIcon,
            group: 'customers',
        },
        {
            name: 'Enquiries',
            children: [
                { name: 'Enquiries', route: 'enquiries', type: 'enquiry' },
                { name: 'Subscribers', route: 'subscribers', type: 'subscriber' },
            ],
            iconComponent: FeatherIcons.MessageSquareIcon,
            group: 'customers',
        },
        {
            name: 'Orders',
            type: 'order',
            route: 'orders',
            iconComponent: FeatherIcons.ShoppingCartIcon,
            group: 'customers',
        },
        {
            name: 'Reports',
            type: 'order_report',
            children: [
                { name: 'Orders', type: 'order_report', route: 'order_reports' },
                { name: 'Products', type: 'product_report', route: 'product_reports' },
                { name: 'Customers', type: 'customer_report', route: 'customer_reports' },
            ],
            iconComponent: FeatherIcons.BarChart2Icon,
            group: 'customers',
        },
        {
            name: 'Accounts',
            children: [
                { name: 'Users', route: 'users', type: 'user' },
                { name: 'Roles', route: 'roles', type: 'role' },
            ],
            iconComponent: FeatherIcons.LockIcon,
            group: 'settings',
        },
        {
            name: 'Settings',
            children: [
                { name: 'Settings', route: 'settings', type: 'setting' },
                { name: 'Redirect URLs', route: 'redirect_urls', type: 'redirect_url' },
            ],
            iconComponent: FeatherIcons.SettingsIcon,
            group: 'settings',
        },
    ],
    defaultItem: 'Content',
}
